import React from 'react'
import styles from './Button.module.css'

const Button = ({name="Button",handleOnClick, width=150, height=40,marginStart=0, marginEnd=0, backgroundColor="#0073FF"}) => {
  return (
    <div className={styles.button} onClick={handleOnClick} style={{width: width,marginInlineStart:marginStart, marginInlineEnd:marginEnd, backgroundColor:backgroundColor, height:height}}>{name}</div>
  )
}

export default Button